import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { get, map } from 'lodash'
import getFp from 'lodash/fp/get'
import { isoDurationToYoutubeFormat } from '../helpers/time'

const transformVideos = response => {
  const videos = map(response?.data, video => ({
    ...video,
    metadata: {
      ...get(video, 'metadata', {}),
      duration: isoDurationToYoutubeFormat(get(video, 'metadata.duration'))
    }
  }))

  return {
    ...response,
    videos
  }
}

const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: builder => ({
    getVideosByPages: builder.query({
      query: page => `/videos?page=${page}&limit=${4}`,
      transformResponse: transformVideos
    }),
    getVideoById: builder.query({
      query: id => `/video/${id}`,
      transformResponse: getFp('data')
    }),
    getViewsByVideo: builder.query({
      query: ({ videoId, page }) => `/video/${videoId}/views?page=${page}&limit=${1}`
    }),
    addViewToVideo: builder.mutation({
      query: videoId => ({
        url: `video/${videoId}/views`,
        method: 'POST',
        body: {
          user: 'FAKE_USER_123'
        }
      })
    }),
    postAnswer: builder.mutation({
      query: payload => ({
        url: `question/${payload?.questionId}/answer`,
        method: 'POST',
        body: {
          user: 'FAKE_USER_123',
          text: payload.text
        }
      })
    })
  })
})

export const {
  useGetVideosByPagesQuery,
  useGetVideoByIdQuery,
  useGetViewsByVideoQuery,
  useAddViewToVideoMutation,
  usePostAnswerMutation
} = api

export default api
